import React from 'react';
import { Route, Switch } from 'react-router';
import Help from './Help'
import Treatment from './Treatment';
import Service from './Service';

export default class BipolarTreatment extends React.Component {
  render() {
    return <div>
      <h1 className="title" style={{ fontSize: '2.5em', margin: '0 0 20px 0' }}>Welcome to Engaged Practice</h1>
      
      <Switch>
        <Route path="/engage1/bipolartreatment/help" component={Help} />
        <Route path="/engage1/bipolartreatment/treatment" component={Treatment} />
        <Route path="/engage1/bipolartreatment/service" component={Service} />
      </Switch>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/BipolarTreatment.js